<script>
import {createEventDispatcher} from 'svelte';
import {IMAGES_V2} from '@/modules/assets/images';

const dispatch = createEventDispatcher()

function emitData(eventName, e) {
  dispatch(eventName, e.target.value);
}
</script>

<style lang="scss">
  .search {
    width: 100%;
    min-height: 40px;
    border: 1px solid #888B94;
    border-radius: 40px;
    box-sizing: border-box;
    gap: 8px;
    &-input {
      outline: none;
      height: 100%;
      background: transparent;
      border: none;
      &::placeholder {
        color: #888B94;
      }
    }
  }
</style>

<div class="df aic ph16 search">
  <img src={IMAGES_V2.SEARCH} alt="search" width="16" height="16" />
  <input class="f1 db f14 search-input" placeholder="Search" {...$$props} on:input={emitData.bind(null, 'change')} />
</div>
